import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { classes } from "./classes";
import { Overlay } from "./Overlay";

const style = css`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;
  transform: translateY(-8rem);
  transition: transform 200ms;
  pointer-events: none;
  line-height: 1.5rem;

  .container {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0 1rem;
  }

  > * {
    pointer-events: auto;
  }

  &.visible {
    transform: none;
  }
`;

export type MessageProps = { visible: boolean; children: JSX.Element };

export const Message = ({ visible, children }: Properties<MessageProps>) => (
  <div class={$(() => classes(style, resolve(visible) && "visible"))}>
    <Overlay visible={visible} border>
      <div class="container">{children}</div>
    </Overlay>
  </div>
);
